// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-attestation-certification__tips[data-v-6fdb96a1]{color:#f76b1c;font-size:12px;line-height:16px;padding:10px 20px;margin:0 -20px;background:rgba(247,107,28,.1)}.g-attestation-certification__main[data-v-6fdb96a1]{padding:30px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
